/* FF wip513 (2026-08-22): shared upsell instrumentation module. Loaded once per
   page (from snippets/cart-drawer.liquid, which renders on every page). Every
   upsell surface (PDP "Complete the room", cart page grid + category tabs, cart
   drawer cross-sell, Recently Viewed) calls into window.FFUpsellTrack instead of
   each wiring its own analytics. Defensive by design: every public method is
   wrapped so a tracking bug can never throw into a surface's own click/add
   handler or block the click itself. Emits to Microsoft Clarity
   (window.clarity, installed sitewide) and GA4 (window.gtag, when present);
   degrades silently if either is missing. No new network calls except the
   explicit /cart.js + /cart/update.js pair used for order-level attribution
   (owner-requested — see ff_upsell_add below), never on click/impression.

   Card contract (rendered by each surface's own Liquid/JS, not this file):
     - rail root:  data-ff-track-surface="<surface>" data-ff-track-anchor='{"h":...,"c":...,"p":...}'
     - each card:  data-ff-track='{"s":"<slot_type>","c":"<item_category>","p":<price>,"fm":<bool>,"li":<bool>,"hr":<bool>}'
                   plus the item handle on data-ff-cr-handle (or data-ff-track-handle).
   Surfaces call FFUpsellTrack.observeImpression(root) once, and
   FFUpsellTrack.trackClick(cardEl) / .trackAdd(cardEl, qty) from their existing
   click/add-success handlers. */
(function () {
  'use strict';
  if (window.FFUpsellTrack) return; /* idempotent if the snippet ever renders twice */

  function safe(fn) {
    return function () {
      try { return fn.apply(this, arguments); } catch (err) { /* never throw into caller */ }
    };
  }

  function readJSON(el, attr) {
    if (!el) return null;
    var raw = el.getAttribute(attr);
    if (!raw) return null;
    try { return JSON.parse(raw); } catch (e) { return null; }
  }

  function num(v) {
    var n = parseFloat(v);
    return isNaN(n) ? undefined : n;
  }

  function closestSurface(el) {
    return el && el.closest ? el.closest('[data-ff-track-surface]') : null;
  }

  function anchorFor(root) {
    if (!root) return {};
    if (root.hasAttribute('data-ff-track-anchor')) return readJSON(root, 'data-ff-track-anchor') || {};
    var withAnchor = root.closest ? root.closest('[data-ff-track-anchor]') : null;
    return readJSON(withAnchor, 'data-ff-track-anchor') || {};
  }

  function itemHandle(cardEl) {
    return cardEl.getAttribute('data-ff-cr-handle') || cardEl.getAttribute('data-ff-track-handle') || '';
  }

  function positionOf(cardEl, root) {
    if (!root) return undefined;
    var items = root.querySelectorAll('[data-ff-track]');
    for (var i = 0; i < items.length; i++) {
      if (items[i] === cardEl) return i + 1;
    }
    return undefined;
  }

  /* --- emit --- */
  function emit(name, payload) {
    if (window.clarity) {
      try { window.clarity('event', name); } catch (e) {}
      try {
        for (var k in payload) {
          if (Object.prototype.hasOwnProperty.call(payload, k) && payload[k] !== undefined && payload[k] !== null) {
            window.clarity('set', name + '_' + k, String(payload[k]));
          }
        }
      } catch (e) {}
    }
    if (window.gtag) {
      try { window.gtag('event', name, payload); } catch (e) {}
    }
  }

  /* --- session-level Clarity tags (filterable across the whole session) --- */
  var SS_SEEN = 'ffUpsellSeenSurfaces';
  var SS_CLICKED = 'ffUpsellClicked';
  var SS_ADDED = 'ffUpsellAdded';

  function setClarityTag(key, value) {
    if (window.clarity) { try { window.clarity('set', key, value); } catch (e) {} }
  }

  function markSeen(surface) {
    var raw = sessionStorage.getItem(SS_SEEN);
    var list = raw ? raw.split(',') : [];
    if (list.indexOf(surface) === -1) {
      list.push(surface);
      sessionStorage.setItem(SS_SEEN, list.join(','));
      setClarityTag('ff_saw_upsell', list.join(','));
    }
  }

  function markClicked() {
    if (sessionStorage.getItem(SS_CLICKED) !== 'yes') {
      sessionStorage.setItem(SS_CLICKED, 'yes');
    }
    setClarityTag('ff_clicked_upsell', 'yes');
  }

  function markAdded() {
    if (sessionStorage.getItem(SS_ADDED) !== 'yes') {
      sessionStorage.setItem(SS_ADDED, 'yes');
    }
    setClarityTag('ff_added_upsell', 'yes');
  }

  /* On load, replay session tags so Clarity has them on every page even if the
     surface that set them isn't present on this particular page. */
  safe(function () {
    var raw = sessionStorage.getItem(SS_SEEN);
    if (raw) setClarityTag('ff_saw_upsell', raw);
    setClarityTag('ff_clicked_upsell', sessionStorage.getItem(SS_CLICKED) === 'yes' ? 'yes' : 'no');
    setClarityTag('ff_added_upsell', sessionStorage.getItem(SS_ADDED) === 'yes' ? 'yes' : 'no');
  })();

  /* --- impression (IntersectionObserver, 50% visible, once per rail root) --- */
  var impressionSeenRoots = new WeakSet ? new WeakSet() : null;

  function buildImpressionPayload(root, surfaceOverride) {
    var anchor = anchorFor(root);
    var cards = root.querySelectorAll('[data-ff-track]');
    var handles = [];
    var hasFamily = false;
    for (var i = 0; i < cards.length; i++) {
      var d = readJSON(cards[i], 'data-ff-track') || {};
      var h = itemHandle(cards[i]);
      if (i < 6 && h) handles.push(h);
      if (d.fm) hasFamily = true;
    }
    return {
      surface: surfaceOverride || root.getAttribute('data-ff-track-surface') || '',
      anchor_handle: anchor.h || '',
      anchor_category: anchor.c || '',
      item_count: cards.length,
      item_handles: handles.join(','),
      has_family_match: !!hasFamily
    };
  }

  function fireImpression(root, surfaceOverride) {
    if (!root) return;
    if (impressionSeenRoots) {
      if (impressionSeenRoots.has(root)) return;
      impressionSeenRoots.add(root);
    }
    var payload = buildImpressionPayload(root, surfaceOverride);
    if (!payload.item_count) return; /* rail with nothing rendered isn't a real impression */
    emit('ff_upsell_impression', payload);
    markSeen(payload.surface);
  }

  var observeImpression = safe(function (root) {
    if (!root || root.getAttribute('data-ff-track-observed') === '1') return;
    root.setAttribute('data-ff-track-observed', '1');
    if (!('IntersectionObserver' in window)) {
      /* No IO support: fall back to firing on init if already in viewport-ish. */
      fireImpression(root);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
          fireImpression(root);
          io.unobserve(root);
        }
      });
    }, { threshold: [0.5] });
    io.observe(root);
  });

  /* Explicit fire for surfaces that aren't scroll-revealed (e.g. a popup that
     opens on click) -- same once-per-root guard, no IntersectionObserver needed. */
  var trackImpressionNow = safe(function (root, surfaceOverride) {
    fireImpression(root, surfaceOverride);
  });

  /* --- click --- */
  var trackClick = safe(function (cardEl) {
    if (!cardEl) return;
    var root = closestSurface(cardEl);
    var anchor = anchorFor(root);
    var d = readJSON(cardEl, 'data-ff-track') || {};
    var itemPrice = num(d.p);
    var anchorPrice = num(anchor.p);
    var payload = {
      surface: (root && root.getAttribute('data-ff-track-surface')) || '',
      anchor_handle: anchor.h || '',
      item_handle: itemHandle(cardEl),
      item_category: d.c || '',
      slot_type: d.s || '',
      position: positionOf(cardEl, root),
      item_price: itemPrice,
      anchor_price: anchorPrice,
      price_ratio: (itemPrice && anchorPrice) ? Math.round((itemPrice / anchorPrice) * 100) / 100 : undefined,
      is_family_match: !!d.fm,
      has_lifestyle_image: !!d.li,
      has_rating: !!d.hr
    };
    emit('ff_upsell_click', payload);
    markClicked();
  });

  /* --- add (hook into each surface's existing successful add-to-cart) --- */
  var pendingAttrWrites = 0;

  function appendAttribution(entry) {
    /* Owner-requested exception to "no new network calls": order-level
       attribution needs the current cart attribute value before appending, so
       this is a read (GET /cart.js) + write (POST /cart/update.js) pair, fired
       only on a real upsell add, never on click/impression. */
    if (pendingAttrWrites > 3) return; /* basic runaway guard */
    pendingAttrWrites++;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var attrs = (cart && cart.attributes) || {};
        var raw = attrs['_ff_upsell_source'] || '';
        var list = raw ? raw.split('||').filter(Boolean) : [];
        list.push(entry);
        if (list.length > 10) list = list.slice(list.length - 10);
        var body = { attributes: {} };
        body.attributes['_ff_upsell_source'] = list.join('||');
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        });
      })
      .catch(function () {})
      .then(function () { pendingAttrWrites--; }, function () { pendingAttrWrites--; });
  }

  var trackAdd = safe(function (cardEl, qty) {
    if (!cardEl) return;
    var root = closestSurface(cardEl);
    var anchor = anchorFor(root);
    var d = readJSON(cardEl, 'data-ff-track') || {};
    var itemPrice = num(d.p);
    var anchorPrice = num(anchor.p);
    var surface = (root && root.getAttribute('data-ff-track-surface')) || '';
    var itemH = itemHandle(cardEl);
    var slot = d.s || '';
    var position = positionOf(cardEl, root);
    var payload = {
      surface: surface,
      anchor_handle: anchor.h || '',
      item_handle: itemH,
      item_category: d.c || '',
      slot_type: slot,
      position: position,
      item_price: itemPrice,
      anchor_price: anchorPrice,
      price_ratio: (itemPrice && anchorPrice) ? Math.round((itemPrice / anchorPrice) * 100) / 100 : undefined,
      is_family_match: !!d.fm,
      has_lifestyle_image: !!d.li,
      has_rating: !!d.hr,
      quantity: qty || 1
    };
    emit('ff_upsell_add', payload);
    markAdded();
    var entry = [surface, anchor.h || '', itemH, slot, (position || '')].join('|');
    appendAttribution(entry);
  });

  /* --- wip543 (2026-09-03): generic emit/tag escape hatches for the drawer +
     protection-toggle instrumentation below, and for snippets/cart-drawer.liquid /
     assets/cart-drawer.js (both load this module first, defer, on every page) to
     reuse the exact same Clarity/GA4 pattern instead of re-implementing it. Same
     defensive contract as everything else here: never throws, degrades silently. */
  var emitEvent = safe(function (name, payload) { emit(name, payload); });
  var setTag = safe(function (key, value) { setClarityTag(key, value); });
  var dwellBucket = function (ms) {
    if (ms == null || isNaN(ms)) return undefined;
    if (ms < 5000) return 'lt5s';
    if (ms < 20000) return '5-20s';
    if (ms < 60000) return '20-60s';
    return 'gt60s';
  };

  /* --- protection/warranty toggle (wip543 2026-09-03) ---
     Two independent widgets, observed by event delegation from this globally-loaded
     module so neither of their owning files needs an edit:
       PDP (sections/ff-main-product-redesign.liquid, wip538's file, READ-ONLY here):
         [data-ff-guardsman] card > [data-ff-guardsman-protected] (hidden attribute
         flips false when the plan is actually confirmed in the cart, true when
         removed -- driven by that file's own setProtected()/removeWarranty(), so
         this reacts to the real persisted state, not just a checkbox click that
         hasn't been submitted yet). Price parsed from .ff-protect-price text in the
         same card; anchor (product) price parsed from .ff-pdp-pricerow text.
       Cart page (sections/main-cart-items.liquid, THIS wave's own file):
         button.ff-protect-toggle, aria-pressed = state, data-price-cents = plan
         price, data-ff-protect-anchor-cents = order subtotal being protected
         (rendered server-side this wave -- see that file's ff_protect_anchor_cents). */
  function parseMoney(el) {
    if (!el) return undefined;
    var m = (el.textContent || '').match(/[\d,]+\.\d{2}|[\d,]+/);
    if (!m) return undefined;
    var n = parseFloat(m[0].replace(/,/g, ''));
    return isNaN(n) ? undefined : n;
  }
  function centsToDollars(raw) {
    var n = num(raw);
    return n === undefined ? undefined : Math.round(n) / 100;
  }
  function toggleRatio(price, anchor) {
    return (price && anchor) ? Math.round((price / anchor) * 100) / 100 : undefined;
  }
  function fireProtectionToggle(surface, state, price, anchor) {
    emit('ff_protection_toggle', {
      state: state,
      surface: surface,
      price: price,
      anchor_price: anchor,
      ratio: toggleRatio(price, anchor)
    });
    setClarityTag('ff_protection_toggled', 'yes');
  }
  var initPdpProtectionWatch = safe(function () {
    var card = document.querySelector('[data-ff-guardsman]');
    if (!card || card.getAttribute('data-ff-track-bound') === '1') return;
    var prot = card.querySelector('[data-ff-guardsman-protected]');
    if (!prot) return;
    card.setAttribute('data-ff-track-bound', '1');
    var wasHidden = prot.hidden;
    var mo = new MutationObserver(safe(function () {
      var nowHidden = prot.hidden;
      if (nowHidden === wasHidden) return;
      wasHidden = nowHidden;
      var price = parseMoney(card.querySelector('.ff-protect-price'));
      var anchor = parseMoney(document.querySelector('.ff-pdp-pricerow'));
      fireProtectionToggle('pdp', nowHidden ? 'off' : 'on', price, anchor);
    }));
    mo.observe(prot, { attributes: true, attributeFilter: ['hidden'] });
  });
  var initCartProtectionWatch = safe(function () {
    var btn = document.querySelector('.ff-protect-toggle');
    if (!btn || btn.getAttribute('data-ff-track-bound') === '1') return;
    btn.setAttribute('data-ff-track-bound', '1');
    var wasPressed = btn.getAttribute('aria-pressed') === 'true';
    var mo = new MutationObserver(safe(function () {
      var nowPressed = btn.getAttribute('aria-pressed') === 'true';
      if (nowPressed === wasPressed) return;
      wasPressed = nowPressed;
      var price = centsToDollars(btn.getAttribute('data-price-cents'));
      var anchor = centsToDollars(btn.getAttribute('data-ff-protect-anchor-cents'));
      fireProtectionToggle('cart', nowPressed ? 'on' : 'off', price, anchor);
    }));
    mo.observe(btn, { attributes: true, attributeFilter: ['aria-pressed'] });
  });
  var scanProtectionWidgets = safe(function () {
    initPdpProtectionWatch();
    initCartProtectionWatch();
  });

  /* "what's covered" opens -- PDP markup (.warranty-link / .ff-protect-covlink /
     #warranty, all inside wip538's file) vs cart page (.ff-warranty-modal-open,
     this wave's own file) are distinct classes, so surface is inferred from which
     was clicked with no ambiguity. Neither exists in the drawer today (its own
     protection block is dead code, {% if false %}-gated -- see WAVE_LEDGER.md
     wip543 notes), so surface:'drawer' never fires; documented, not a gap. */
  document.addEventListener('click', safe(function (event) {
    var t = event.target;
    if (!t || !t.closest) return;
    if (t.closest('#warranty, .warranty-link, .ff-protect-covlink')) {
      emit('ff_whats_covered_open', { surface: 'pdp' });
    } else if (t.closest('.ff-warranty-modal-open')) {
      emit('ff_whats_covered_open', { surface: 'cart' });
    }
  }));

  /* --- wip577 (2026-09-10): block-level impression tracking for the PDP trust
     content that had zero visibility measurement -- THE FORWARD GUARANTEE
     card, the stock line, the delivery line, the protection/"what's covered"
     card, and the two warranty/care accordions -- plus the Add to Cart button
     and the rail, folded into the SAME event so every block can be read from
     one table instead of mixing this with ff_upsell_impression. Reuses
     observeImpression's IntersectionObserver threshold (0.5) and
     once-per-root semantics (Doc D wip574_levers), but additionally requires
     the 50%-visible state to hold for >=500ms before firing, so a fast
     scroll-past doesn't count as "seen". Every selector below is an existing,
     already-unique attribute/class already on non-hero PDPs today -- no new
     data attributes were needed in the Liquid templates. Six of the seven
     (guarantee/stock/delivery/protection_card/accordions/rail) live only
     inside this section, which doesn't render on hero PDPs at all -- same
     non-hero condition the rail tracker above already relies on. The ATC
     button is the one exception: `.product-form__submit[name="add"]` is a
     generic Dawn class Bliss/Olivia/Haven's OWN product form also carries
     (confirmed live), so it alone is scoped under `.ff-pdp-redesign`, this
     file's own existing scoping idiom for "the non-hero info column" (see
     e.g. `.ff-pdp-redesign .ff-pdp-guarantee` a few hundred lines up) -- that
     wrapper class is not present on hero PDPs, confirmed live on Bliss. */
  var BLOCK_SELECTORS = {
    guarantee: '[data-ff-guarantee]',
    stock: '[data-ff-stockline]',
    delivery: '[data-ff-shipline]',
    protection_card: '[data-ff-guardsman]',
    accordions: '[data-ff-accordion]',
    atc: '.ff-pdp-redesign .product-form__submit[name="add"]',
    rail: '[data-ff-track-surface="pdp_complete_room"]'
  };
  var BLOCK_DWELL_MS = 500;
  var blockImpressionSeen = {};

  function pctScrolled() {
    var doc = document.documentElement;
    var scrollable = (doc.scrollHeight || 0) - (window.innerHeight || doc.clientHeight || 0);
    if (scrollable <= 0) return 100;
    var y = window.pageYOffset || doc.scrollTop || 0;
    return Math.max(0, Math.min(100, Math.round((y / scrollable) * 100)));
  }

  function fireBlockImpression(block) {
    if (blockImpressionSeen[block]) return;
    blockImpressionSeen[block] = true;
    emit('ff_block_impression', {
      block: block,
      device: window.innerWidth < 768 ? 'mobile' : 'desktop',
      pct_scrolled: pctScrolled()
    });
    if (block === 'guarantee') setClarityTag('ff_seen_guarantee', 'yes');
  }

  var observeBlockImpression = safe(function (el, block) {
    if (!el || el.getAttribute('data-ff-block-observed') === '1') return;
    el.setAttribute('data-ff-block-observed', '1');
    if (!('IntersectionObserver' in window)) { fireBlockImpression(block); return; }
    var dwellTimer = null;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
          if (dwellTimer) return;
          dwellTimer = setTimeout(function () {
            fireBlockImpression(block);
            io.unobserve(el);
          }, BLOCK_DWELL_MS);
        } else if (dwellTimer) {
          clearTimeout(dwellTimer);
          dwellTimer = null;
        }
      });
    }, { threshold: [0.5] });
    io.observe(el);
  });

  var scanBlockImpressions = safe(function () {
    for (var block in BLOCK_SELECTORS) {
      if (!Object.prototype.hasOwnProperty.call(BLOCK_SELECTORS, block)) continue;
      var el = document.querySelector(BLOCK_SELECTORS[block]);
      if (el) observeBlockImpression(el, block);
    }
  });

  /* Auto-scan for late-appearing rails (AJAX cart drawer content, cart page tab
     switches, etc.) so surfaces don't all have to remember to call
     observeImpression a second time after re-rendering. Also re-checks the
     protection-toggle widgets above (wip543) -- both are cheap no-ops once bound
     via the data-ff-track-bound guard, so folding them into this existing debounced
     observer avoids adding a second full-document MutationObserver. wip577 folds
     its own block-impression scan into the same debounced pass, same reasoning. */
  safe(function () {
    function scan() {
      var roots = document.querySelectorAll('[data-ff-track-surface]:not([data-ff-track-observed])');
      for (var i = 0; i < roots.length; i++) observeImpression(roots[i]);
      scanProtectionWidgets();
      scanBlockImpressions();
    }
    if (document.readyState !== 'loading') scan(); else document.addEventListener('DOMContentLoaded', scan);
    if ('MutationObserver' in window) {
      var scheduled = false;
      var mo = new MutationObserver(function () {
        if (scheduled) return;
        scheduled = true;
        setTimeout(function () { scheduled = false; scan(); }, 300);
      });
      mo.observe(document.documentElement, { childList: true, subtree: true });
    }
  })();

  window.FFUpsellTrack = {
    observeImpression: observeImpression,
    trackImpressionNow: trackImpressionNow,
    trackClick: trackClick,
    trackAdd: trackAdd,
    emitEvent: emitEvent,
    setTag: setTag,
    dwellBucket: dwellBucket
  };
})();
